import React, { useEffect } from 'react';
import { BrowserRouter, Navigate, Route, Routes, useLocation } from 'react-router-dom';
import { Navbar } from './components/Navbar';
import { Footer } from './components/Footer';
import { Home } from './pages/Home';
import { Locations } from './pages/Locations';
import { LocationDetail } from './pages/LocationDetail';
import { Services } from './pages/Services';
import { Book } from './pages/Book';
import { Contact } from './pages/Contact';
function ScrollToTop() {
  const {
    pathname
  } = useLocation();
  useEffect(() => {
    window.scrollTo({
      top: 0
    });
  }, [pathname]);
  return null;
}
export function App() {
  return <BrowserRouter data-id="element-0" data-mp="31c1iue7j1yhb">
      <ScrollToTop data-id="element-1" data-mp="31cjk5p91r2w3" />
      <div className="flex min-h-screen w-full flex-col bg-black" data-id="element-2" data-mp="2wjgqzi86lvgf">
        <Navbar data-id="element-3" data-mp="2wi5n7ieqknpb" />
        <div className="flex-1" data-id="element-4" data-mp="28ufm24yk52fw">
          <Routes data-id="element-5" data-mp="28te2td7e19n3">
            <Route path="/" element={<Home data-id="element-7" data-mp="28s2xva27hvue" />} data-id="element-6" data-mp="28suvsrja05nu" />
            <Route path="/locations" element={<Locations data-id="element-9" data-mp="23u9qidp62vsj" />} data-id="element-8" data-mp="23vkuoemiy5k6" />
            <Route path="/locations/:slug" element={<LocationDetail data-id="element-11" data-mp="3ik7jmqgv0tve" />} data-id="element-10" data-mp="23v2u55stx56g" />
            <Route path="/services" element={<Services data-id="element-13" data-mp="3ihv1ac76whht" />} data-id="element-12" data-mp="3ij66mgga9xb1" />
            <Route path="/book" element={<Book data-id="element-15" data-mp="3mkhmvvd9p66k" />} data-id="element-14" data-mp="3mlax56bfqdtg" />
            <Route path="/contact" element={<Contact data-id="element-17" data-mp="3rc9du70c5dx8" />} data-id="element-16" data-mp="3mjq1fdddwou0" />
            <Route path="*" element={<Navigate to="/" replace data-id="element-19" data-mp="3rdkg22e4udm8" />} data-id="element-18" data-mp="3rbzn2h7gv2qh" />
          </Routes>
        </div>
        <Footer data-id="element-20" data-mp="67z9oh5w26u" />
      </div>
    </BrowserRouter>;
}